export enum ChatMessageType {
  VIDEO_MESSAGE = 'video_message',
  AUDIO_MESSAGE = 'audio_message',
  FILE_MESSAGE = 'file_message',
  IMAGE_MESSAGE = 'image_message',
  TEXT_MESSAGE = 'text_message',
  LOADING_MESSAGE = 'loading_message',
  ADAPTIVE_CARD = 'adaptive_card'
}
